<template>
    <div class="app">
        <GroupAuth />
    </div>
</template>

<script setup>
import GroupAuth from '@/components/Group/GroupAuth.vue'
</script>